import React from 'react'

import stateApi from 'core/application/adminSignUp/qsehra/state'
import qsehraWizardApi from 'core/application/adminSignUp/qsehra/wizard'

import AdminSignUpWizard from '../common/AdminSignUpWizard'

import '../SignupStyles.less'

const QsehraAdminSignupWizard: React.FC = () => {
  return <AdminSignUpWizard getWizard={() => qsehraWizardApi()} getWizardState={() => stateApi()} />
}

export default QsehraAdminSignupWizard
